import React, { useState } from 'react';
import {
  Modal,
  Box, // Box vẫn dùng được trong v4, nhưng style sẽ thông qua makeStyles
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Button,
  IconButton,
  FormControl,
  FormLabel,
  FormGroup,
  Snackbar,
} from '@material-ui/core'; // Chú ý cách import từ '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'; // Import makeStyles
import CloseIcon from '@material-ui/icons/Close'; // Import icons từ '@material-ui/icons'
import CustomAlert from '../component/CustomAlert';
import FullScreenLoading from '../component/FullScreenLoading';
import { sendDataToGoogleSheet } from '../services/GuiDuLieuService';

// Định nghĩa styles bằng makeStyles
const useStyles = makeStyles((theme) => ({
  modalPaper: {
    position: 'absolute',
    width: '90%', // Chiều rộng 90% trên mobile
    maxWidth: 500, // Tối đa 500px trên desktop
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[24],
    padding: theme.spacing(4),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none', // Remove focus outline
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  headerText: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  introText: {
    marginBottom: theme.spacing(2),
  },
  boldText: {
    fontWeight: 'bold',
  },
  phoneNumber: {
    fontWeight: 'bold',
    color: theme.palette.primary.main, // Sử dụng màu primary của theme
  },
  formControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  submitButton: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.warning.main, // Sử dụng màu warning của theme nếu có
    '&:hover': {
      backgroundColor: theme.palette.warning.dark, // Tùy chỉnh màu hover
    }
  },
  formControl: {
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      width: '90%', // Trên màn hình nhỏ hơn, cho FormControl rộng hơn
    },
    textAlign: 'left'
  },
  boxForm: {
    display: 'flex',
    flexDirection: 'column'
  }
}));

const YeuCauBaoGiaModal = ({ open, onClose }) => {
  const classes = useStyles(); // Gọi useStyles để lấy classes
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    hoTen: '',
    diaChi: '',
    soDienThoai: '',
    chonXe: [], // Array để lưu các xe được chọn
    hinhThuc: 'Trả góp', // Mặc định là 'TraGop'
    noiDung: '',
    thanhpho: 'Thái Nguyên',
    daily: 'Thái Nguyên Ford',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      if (type === 'checkbox') {
        const newChonXe = checked
          ? [...prevData.chonXe, value]
          : prevData.chonXe.filter((xe) => xe !== value);
        return { ...prevData, chonXe: newChonXe };
      } else {
        return { ...prevData, [name]: value };
      }
    });
  };

  const GOOGLE_APP_SCRIPT_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbwCF_OdEm_HoqFLNZF_P614ORKuhKDsXsfNrtES1uEzauBcbJNFfJ53dEFotDp0K4MN/exec';
  const TARGET_SHEET_NAME = 'yeu-cau-bao-gia';
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let xe = ''; // Khởi tạo biến xe
    if (formData.chonXe) {
      formData.chonXe.forEach(element => {
        xe = xe + element + ', '
      });
    }
    let body = {
      ...formData,
      xe: xe
    }
    console.log(body)
    try {
      await sendDataToGoogleSheet(GOOGLE_APP_SCRIPT_WEB_APP_URL, body, TARGET_SHEET_NAME);
      setSnackbar({
        open: true,
        message: 'Yêu cầu của bạn đã được gửi thành công!',
        severity: 'success',
      });
      setFormData({
        hoTen: '',
        diaChi: '',
        soDienThoai: '',
        thanhpho: 'Thái Nguyên',
        daily: 'Thái Nguyên Ford',
        chonXe: [], // Array để lưu các xe được chọn
        thoiGian: '', // Mặc định là 'TraGop'
        noiDung: '',
      });
    } catch (error) {
      // Xử lý lỗi nếu hàm sendDataToGoogleSheet ném lỗi
      console.error('Lỗi khi gửi form:', error);
      setSnackbar({
        open: true,
        message: `Có lỗi xảy ra: ${error.message}. Vui lòng thử lại.`,
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        {/* Box thay thế cho Paper hoặc div để áp dụng styles */}
        <div className={classes.modalPaper}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="h2" className={classes.headerText} id="modal-title">
            ĐĂNG KÝ NHẬN BÁO GIÁ
          </Typography>

          <Typography variant="body2" className={classes.introText} id="modal-description">
            <Typography component="span" className={classes.boldText}>Ford Thái Nguyên</Typography> tặng ngay Camera hành trình chính hãng trị giá 5.000.000 khi khách hàng để lại số điện thoại nhận báo giá
          </Typography>

          <Box className={classes.boxForm}>
            <FormControl className={classes.formControl}>
              <TextField
                label="Họ và tên"
                name="hoTen"
                value={formData.hoTen}
                onChange={handleChange}
                fullWidth
                size="small" // size="small" hoặc "medium"
              />
            </FormControl>

            <FormControl className={classes.formControl}>
              <TextField
                label="Địa chỉ"
                name="diaChi"
                value={formData.diaChi}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </FormControl>

            <FormControl className={classes.formControl}>
              <TextField
                label="Điện thoại"
                name="soDienThoai"
                value={formData.soDienThoai}
                onChange={handleChange}
                fullWidth
                size="small"
                type="tel"
              />
            </FormControl>


            <FormControl component="fieldset" className={classes.formControl} fullWidth>
              <FormLabel component="legend">Chọn xe:</FormLabel>
              <FormGroup row>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.chonXe.includes('Everest')}
                      onChange={handleChange}
                      name="chonXe"
                      value="Everest"
                      size="small"
                    />
                  }
                  label="Everest"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.chonXe.includes('Ranger')}
                      onChange={handleChange}
                      name="chonXe"
                      value="Ranger"
                      size="small"
                    />
                  }
                  label="Ranger"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.chonXe.includes('Territory')}
                      onChange={handleChange}
                      name="chonXe"
                      value="Territory"
                      size="small"
                    />
                  }
                  label="Territory"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.chonXe.includes('Explorer')}
                      onChange={handleChange}
                      name="chonXe"
                      value="Explorer"
                      size="small"
                    />
                  }
                  label="Explorer"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.chonXe.includes('Transit')}
                      onChange={handleChange}
                      name="chonXe"
                      value="Transit"
                      size="small"
                    />
                  }
                  label="Transit"
                />
              </FormGroup>
            </FormControl>

            <FormControl component="fieldset" className={classes.formControl} fullWidth>
              <FormLabel component="legend">Hình thức:</FormLabel>
              <RadioGroup row name="hinhThuc" value={formData.hinhThuc} onChange={handleChange}>
                <FormControlLabel
                  value="Trả góp"
                  control={<Radio size="small" />}
                  label="Trả góp"
                />
                <FormControlLabel
                  value="Trả hết"
                  control={<Radio size="small" />}
                  label="Trả hết"
                />
              </RadioGroup>
            </FormControl>

            <FormControl className={classes.formControl}>
              <TextField
                label="Ghi chú"
                name="noiDung"
                value={formData.noiDung}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </FormControl>

            <Button
              type="submit"
              variant="contained"
              className={classes.submitButton} // Sử dụng className để áp dụng styles
              fullWidth
              onClick={handleSubmit} // Gắn onClick cho Button thay vì onSubmit trên form nếu bạn muốn kiểm soát sự kiện bằng Button
            >
              GỬI YÊU CẦU
            </Button>
          </Box>
        </div>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <CustomAlert message={snackbar.message} onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }} />
      </Snackbar>
      {loading && <FullScreenLoading />}
    </>
  );
}

export default YeuCauBaoGiaModal;